import styles from "./restaurant-menu-list-item.module.less";

const RestaurantMenuListItem = (props) => {
  return (
    <div className={styles.wrapper}>
      <div className={styles.topRow}>
        <div className={styles.name}>{props.name}</div>
        {props.price && <div className={styles.price}>{props.price}</div>}
      </div>
      {props.description && <p className={[styles.description, "p_small"].join(" ")}>{props.description}</p>}
    </div>
  );
};

export default RestaurantMenuListItem;
